import menuAround from './menu-around.vue';

export default menuAround;
